// this page created by akash-ak
import { useState, useEffect } from "react";
import Tabs from "../../../../Components/Tabs";
import GetIcon from "../../../../utils/Icon";
import { Link } from "react-router-dom";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import { useGetPurchaseOrderListMutation, useUploadFileMutation, useCreateGateEntryMutation, useGetVehicleListMutation, useUpdateGateEntryMutation, useSubmitGateEntryMutation ,useGetGateEntryByIdQuery} from '../../../../store/api/gateEntryApiNew'
import { useGetVendorListMutation } from "../../../../store/api/purchaseorderapi";
import Table from "./Table";
import { useNavigate } from 'react-router-dom';

const PurchaseForm = ({ gateId }) => {
    const nvg = useNavigate(); 
  console.log(gateId,"gateId");
  const {
  data: gateEntryData,
  isLoading: gateEntryLoading,
  error: gateEntryError,
} = useGetGateEntryByIdQuery(gateId);
useEffect(() => {
  if (gateEntryData?.message) {
    const data = gateEntryData.message;

    // Set gate entry name for update & submit
    setgateentry(data.name);

    // Tab 1 form
    setTabOneFormData({
      naming_series: data.name || '',
      select_transaction_type: data.select_transaction_type || '',
      builty_no: data.builty_no || '',
      asn_no: data.asn_no || '',
      vendor_name: data.vendor_name || '',
    });

    // Tab 2 form
    setTabTwoFormData({
      invoice_no: data.invoice_no || '',
      invoice_image: data.invoice_image || null,
      invoice_date: data.invoice_date || '',
      total_no_boxes: data.total_no_boxes || '',
      invoice_value: data.invoice_value || '',
      total_invoice_qty: data.total_invoice_qty || '',
      eway_bill: data.eway_bill || '',
    });

    // Tab 3 form
    setTabThreeFormData({
      vehicle_no: data.vehicle_no || '',
      vehicle_arrival_date: data.vehicle_arrival_date || '',
      vehicle_arrival_time: data.vehicle_arrival_time || '',
      select_vehicle: data.select_vehicle || '',
      transport_method: data.transport_method || '',
      driver_name: data.driver_name || '',
      transporter: data.transporter || '',
      driver_mobile_no: data.driver_mobile_no || '',
      sh_weight: data.sh_weight || '',
      vehicle_condition: data.vehicle_remarks || '',
      vehicle_image: data.vehicle_image || null,
    });

    // Table Items
    if (Array.isArray(data.table_phxi)) {
      const tableItems = data.table_phxi.map(item => ({
        item_code: item.purchase_order,
        quantity: item.box,
      }));
      setselected_item_data(tableItems);
    }

    // Optional: if already submitted, disable submit button
    if (data.docstatus === 1) {
      setsubmit(true);
      setpo_status('submitted');
    }
  }
}, [gateEntryData]);

  
  const [submit, setsubmit] = useState(false);
  const [gateentry, setgateentry] = useState();
  const [po_status, setpo_status] = useState('');
  const [getitem_list_data] = useGetPurchaseOrderListMutation();
  const [uploadFile] = useUploadFileMutation();
  const [vendor_list, setvendor_list] = useState([]);
  const [vehicle_list, setvehicle_list] = useState([]);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);

  const requiredFields = {
    tab1: ['select_transaction_type', 'vendor_name'],
    tab2: ['invoice_no', 'invoice_date', 'total_no_boxes'],
    tab3: ['vehicle_no', 'vehicle_arrival_date', 'vehicle_arrival_time', 'select_vehicle']
  };

  console.log(selected_item_data,"selected_item_data");
  
  const [fieldErrors, setFieldErrors] = useState({
    tab1: {},
    tab2: {},
    tab3: {}
  });

  const [tabOneFormData, setTabOneFormData] = useState({
    naming_series: '',
    select_transaction_type: '',
    builty_no: '',
    asn_no: '',
    vendor_name: '',
  });

  const [tabTwoFormData, setTabTwoFormData] = useState({
    invoice_no: '',
    invoice_image: null,
    invoice_date: '',
    total_no_boxes: '',
    invoice_value: '',
    total_invoice_qty: '',
    eway_bill: '',
  });

  const [tabThreeFormData, setTabThreeFormData] = useState({
    vehicle_no: '',
    vehicle_arrival_date: '',
    vehicle_arrival_time: '',
    select_vehicle: '',
    transport_method: '',
    driver_name: '',
    transporter: '',
    driver_mobile_no: '',
    sh_weight: '',
    vehicle_condition: '',
    vehicle_image: null
  });

  useEffect(() => {
    if (selected_item_data.length > 0) {
      const totalBoxes = selected_item_data.reduce((sum, item) => {
        return sum + parseInt(item.quantity || 0);
      }, 0);

      setTabTwoFormData((prev) => ({
        ...prev,
        total_no_boxes: totalBoxes,
      }));
    }
  }, [selected_item_data]);

  const [getvendor_list] = useGetVendorListMutation();
  const getVendorAndWarehouse = async () => {
    const venderApiData = await getvendor_list()
    setvendor_list(venderApiData.data.result);
  }

  const [getVehicleList, { isLoading: vehicleLoading, error: vehicleError }] = useGetVehicleListMutation();
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await getVehicleList({ doctype: 'Vehicle' }).unwrap();
        const values = response?.message?.values || [];
        const formattedList = values.map(([name]) => ({ name }));
        setvehicle_list(formattedList);
      } catch (err) {
        console.error('Error fetching vehicles:', err);
      }
    };
    fetchVehicles();
  }, [getVehicleList]);

  useEffect(() => {
    getVendorAndWarehouse()
  }, [])

  const validateForm = () => {
    const newErrors = {
      tab1: {},
      tab2: {},
      tab3: {}
    };

    let isValid = true;

    requiredFields.tab1.forEach(field => {
      if (!tabOneFormData[field]) {
        newErrors.tab1[field] = true;
        isValid = false;
      }
    });

    requiredFields.tab2.forEach(field => {
      if (!tabTwoFormData[field]) {
        newErrors.tab2[field] = true;
        isValid = false;
      }
    });

    requiredFields.tab3.forEach(field => {
      if (!tabThreeFormData[field]) {
        newErrors.tab3[field] = true;
        isValid = false;
      }
    });

    setFieldErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (fieldName, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab1: {
        ...prev.tab1,
        [fieldName]: false
      }
    }));
    setTabOneFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleTabTwoInputChange = async (key, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab2: {
        ...prev.tab2,
        [key]: false
      }
    }));

    if (key === "invoice_image") {
      const fileUrl = await handleFileUpload(value, uploadFile);
      if (fileUrl) {
        setTabTwoFormData(prev => ({ ...prev, [key]: fileUrl }));
      }
    } else {
      setTabTwoFormData(prev => ({ ...prev, [key]: value }));
    }
  };

  const handleTabThreeInputChange = async (key, value) => {
    setFieldErrors(prev => ({
      ...prev,
      tab3: {
        ...prev.tab3,
        [key]: false
      }
    }));

    if (key === "vehicle_image") {
      const fileUrl = await handleFileUpload(value, uploadFile);
      if (fileUrl) {
        setTabThreeFormData(prev => ({ ...prev, [key]: fileUrl }));
      }
    } else {
      setTabThreeFormData(prev => ({ ...prev, [key]: value }));
    }
  };

  const handleFileUpload = async (file, uploadFileMutation) => {
    const formData = new FormData();
    formData.append('file', file[0]);
    try {
      const res = await uploadFileMutation(formData);
      const fileUrl = res?.data?.message?.file_url;
      return fileUrl;
    } catch (error) {
      console.error("File upload failed:", error);
      return null;
    }
  };

  const preparePayload = () => {
    const payload = {
      doctype: "Gate Entry",
      naming_series: '',
      select_transaction_type: tabOneFormData.select_transaction_type,
      invoice_no: tabTwoFormData.invoice_no,
      builty_no: tabOneFormData.builty_no,
      invoice_date: tabTwoFormData.invoice_date,
      invoice_value: parseFloat(tabTwoFormData.invoice_value) || 0,
      total_invoice_qty: parseInt(tabTwoFormData.total_invoice_qty) || 0,
      eway_bill: tabTwoFormData.eway_bill,
      invoice_image: tabTwoFormData.invoice_image,
      vehicle_no: tabThreeFormData.vehicle_no,
      vehicle_image: tabThreeFormData.vehicle_image,
      vehicle_arrival_date: tabThreeFormData.vehicle_arrival_date,
      vehicle_arrival_time: tabThreeFormData.vehicle_arrival_time,
      select_vehicle: tabThreeFormData.select_vehicle,
      transport_method: tabThreeFormData.transport_method,
      driver_name: tabThreeFormData.driver_name,
      transporter: tabThreeFormData.transporter,
      driver_mobile_no: tabThreeFormData.driver_mobile_no,
      sh_weight: tabThreeFormData.sh_weight,
      vehicle_remarks: tabThreeFormData.sh_vehicle_conditionweight,
      total_no_boxes: tabTwoFormData.total_no_boxes,
      vendor_name: tabOneFormData.vendor_name,
      table_phxi: selected_item_data.map(item => ({
        purchase_order: item.item_code,
        box: item.quantity,
      })),
    };

    if (gateentry) {
      payload.name = gateentry;
    }

    return payload;
  };

  const [createGateEntry] = useCreateGateEntryMutation();

  const saveData = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    const payload = preparePayload();

    try {
      const response = await createGateEntry(payload).unwrap();
      const gateEntryName = response?.message?.data?.name || '';
      setTabOneFormData(prev => ({
        ...prev,
        naming_series: gateEntryName,
      }));
      setgateentry(gateEntryName)
      setError('Gate Entry Created');
      setptype('Success');
      setShowError(true);
    } catch (err) {
      console.error('Error creating gate entry:', err);
      setError('Error creating gate entry');
      setptype('Error');
      setShowError(true);
    }
  };

  const [updateGateEntry] = useUpdateGateEntryMutation();

  const handleUpdate = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    const payload = preparePayload();
    try {
      const response = await updateGateEntry(payload).unwrap();
      setError('Gate Entry Updated');
      setptype('Success');
      setShowError(true);
    } catch (error) {
      console.error('Update failed:', error);
      setError('Error updating gate entry');
      setptype('Error');
      setShowError(true);
    }
  };

  const [submitGateEntry] = useSubmitGateEntryMutation();

  const handleSubmit = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const response = await submitGateEntry({ gate_entry_name: gateentry }).unwrap();
      setError('Gate Entry Submitted');
      setptype('Success');
      setShowError(true);
      setsubmit(true)
      setpo_status('submitted')
    } catch (error) {
      console.error('Submission failed:', error);
      setError('Error submitting gate entry');
      setptype('Error');
      setShowError(true);
    }
  };

  return (
    <>
      <Tabs />
      <div className="d-flex justify-content-between p-2" style={{ background: "#fcfdfe" ,height : '40px'}}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item">Inbound</p>
          <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
          <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/inbound/gate-entry/gate-entry-list')}>Gate Entry List</p>
          <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>

     
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }}>
            View Gate Entry
            {/* <button className="rounded-pill newdesign123">
              New
            </button> */}
          </a>
        </div>
        {/* <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
          <p style={{ backgroundColor: '#fff', textDecoration: 'none', display: "none" }} className="custom-btn-00989blue m-0">
            + Create Purchase Receipt
          </p>
          {!submit && (
            <>
              {!gateentry && (
                <p
                  style={{ textDecoration: "none", display: "flex" }}
                  className="custom-btn-00989 m-0"
                  onClick={saveData}
                >
                  <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                  Save
                </p>
              )}

              {gateentry && (
                <>
                  <p
                    style={{ textDecoration: "none", display: "flex" }}
                    className="custom-btn-00989 m-0"
                    onClick={handleUpdate}
                  >
                    <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                    Update
                  </p>

                  <p
                    style={{ textDecoration: "none", display: "flex" }}
                    className="custom-btn-00989 m-0"
                    onClick={handleSubmit}
                  >
                    <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
                    Submit
                  </p>
                </>
              )}
            </>
          )}

          <Link
            to="/"
            style={{ backgroundColor: '#fff', textDecoration: 'none', padding: '0px 5px' }}
            className="importbtn">
            <GetIcon iconName='AiOutlinePrinter' size={14} /> &nbsp;
          </Link>
        </div> */}
      </div>
      <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", height: "1200px" }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12" >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                vendor={{ vendor_list: vendor_list, Error: fieldErrors.vendor }}
                onInputChange={handleInputChange}
                tabOneFormData={tabOneFormData}
                errors={fieldErrors.tab1}
              />
              <Tab2
                tabTwoFormData={tabTwoFormData}
                onInputChange={handleTabTwoInputChange}
                errors={fieldErrors.tab2}
              />
              <Tab3
                vendor_list={vendor_list}
                vehicle_list={vehicle_list}
                tabThreeFormData={tabThreeFormData}
                onInputChange={handleTabThreeInputChange}
                errors={fieldErrors.tab3}
              />
              <Table
                setselected_item_data={setselected_item_data}
                list_data={getitem_list_data}
                po_status={po_status}
                selected_item_data={selected_item_data}
              />
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default PurchaseForm;